
import React from 'react';
// Fix: Import Page type from correct location
import { Page } from '../types';

interface HowItWorksProps {
  navigate: (page: Page) => void;
}

const HowItWorks: React.FC<HowItWorksProps> = ({ navigate }) => {
  const steps = [
    { num: '01', title: 'Warteliste', desc: 'Trage dich jetzt unverbindlich ein, um den Release nicht zu verpassen.' },
    { num: '02', title: 'Early Access', desc: 'Erhalte exklusive Vorab-Einblicke und werde Teil unserer Beta-Community.' },
    { num: '03', title: 'Release-Launch', desc: 'Wir benachrichtigen dich, sobald die App im Store zum Download bereitsteht.' },
    { num: '04', title: 'Wissen festigen', desc: 'Starte dein Training und werde zum selbstbewussten Lebensretter.' }
  ];

  return (
    <div className="container mx-auto px-4 md:px-6">
      <div className="text-center mb-20">
        <h2 className="text-3xl md:text-5xl font-extrabold mb-6 leading-tight">Dein Weg zum Retter-Status</h2>
        <p className="text-gray-300 max-w-2xl mx-auto text-lg leading-relaxed">
          Bereite dich jetzt auf den Launch vor. Wir halten dich über jeden Entwicklungsschritt auf dem Laufenden.
        </p>
      </div>

      <div className="relative">
        <div className="hidden lg:block absolute top-10 left-0 w-full h-0.5 bg-white/10 z-0"></div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 relative z-10">
          {steps.map((s, i) => (
            <div key={i} className="text-center group">
              <div className="w-20 h-20 bg-primary rounded-full flex items-center justify-center text-2xl font-black mx-auto mb-8 border-4 border-secondary shadow-xl transition-transform group-hover:scale-110">
                {s.num}
              </div>
              <h3 className="text-xl font-bold mb-4">{s.title}</h3>
              <p className="text-gray-300 text-sm leading-relaxed">
                {s.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
      
      <div className="mt-20 text-center">
        <button 
          // Changed from 'download' to 'warteliste' to match the Page type definition
          onClick={() => navigate('warteliste')}
          className="bg-white text-secondary px-10 py-4 rounded-2xl font-black text-lg hover:scale-105 transition-all shadow-2xl active:scale-95"
        >
          Jetzt auf Warteliste setzen
        </button>
      </div>
    </div>
  );
};

export default HowItWorks;
